var React = require('react');

function IconMenuMobileAbierto (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.3808 5.25628C18.7225 4.91457 19.2774 4.91457 19.6191 5.25628C19.9608 5.59799 19.9608 6.15285 19.6191 6.49456L13.2382 12.8754L19.6191 19.2563L19.6786 19.3227C19.9592 19.6664 19.9395 20.1741 19.6191 20.4946C19.2986 20.815 18.7909 20.8347 18.4472 20.5541L18.3808 20.4946L11.9999 14.1137L5.61907 20.4946C5.27737 20.8363 4.7225 20.8363 4.38079 20.4946C4.03908 20.1529 4.03908 19.598 4.38079 19.2563L10.7617 12.8754L4.38079 6.49456L4.32122 6.42816C4.04064 6.08447 4.06034 5.57673 4.38079 5.25628C4.70124 4.93583 5.20899 4.91613 5.55267 5.19671L5.61907 5.25628L11.9999 11.6371L18.3808 5.25628Z","fill":"white"}));
}

IconMenuMobileAbierto.defaultProps = {"width":"24","height":"26","viewBox":"0 0 24 26","fill":"none"};

module.exports = IconMenuMobileAbierto;

IconMenuMobileAbierto.default = IconMenuMobileAbierto;
